import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters(['user', 'programsList', 'employeesList', 'providerType']),
    isServiceHubEnabled() {
      const sub = this.user?.subscriptions;
      if (!this.user.subscriptionEnabled) {
        return this.providerType === 'service_hub' || this.providerType === 'default';
      }
      return sub?.service_hub?.status === 'active';
    },
    isSalesHubEnabled() {
      const sub = this.user?.subscriptions;
      if (!this.user.subscriptionEnabled) {
        return this.providerType === 'sales_hub' || this.providerType === 'default';
      }
      return sub?.sales_hub?.status === 'active';
    },
    bothHubsEnabled() {
      return this.isServiceHubEnabled && this.isSalesHubEnabled;
    },
    serviceHubLimitReached() {
      if (!this.user?.licenseLimitEnabled) return false;
      const sub = this.user?.subscriptions?.service_hub;
      if (!sub || sub.status !== 'active' || sub.usersCount === null) return false;
      return sub.usedCount >= sub.usersCount;
    },
    salesHubLimitReached() {
      if (!this.user?.licenseLimitEnabled) return false;
      const sub = this.user?.subscriptions?.sales_hub;
      if (!sub || sub.status !== 'active' || sub.usersCount === null) return false;
      return sub.usedCount >= sub.usersCount;
    },
    // Seats exceeded = sales_hub is active AND operators strictly exceed paid seats.
    // Prefer the backend flag (`user.seatsExceeded`) when present; fall back to local
    // subscription counts so the UI stays correct even if the flag is stale.
    // Note: salesHubLimitReached uses >= ("at capacity"); seatsExceeded uses >
    // ("over capacity") — they are intentionally distinct.
    seatsExceeded() {
      if (this.user?.seatsExceeded) return true;
      const sub = this.user?.subscriptions?.sales_hub;
      if (!sub || sub.status !== 'active' || sub.usersCount == null) return false;
      return sub.usedCount > sub.usersCount;
    },
  },
  methods: {
    isLicenseLimitReached(productId) {
      if (!this.user?.licenseLimitEnabled) return false;
      const sub = this.user?.subscriptions?.[productId];
      if (!sub || sub.status !== 'active' || sub.usersCount === null) return false;
      return sub.usedCount >= sub.usersCount;
    },
  },
};
